import { alpha, Box, Typography, styled } from '@mui/material'

interface IMilestoneItemProps {
  icon: string
  label: string
  date: string
  color: string
}

const MilestoneItemRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flex: 'none'
}))

const IconCircle = styled(Box)<{ color: string }>(({ color }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  flexShrink: 0,
  background: alpha(color, 0.12),

  '& .material-symbols-outlined': {
    color,
    fontSize: '18px'
  }
}))

export const MilestoneItem: React.FC<IMilestoneItemProps> = ({
  icon,
  label,
  date,
  color
}) => {
  return (
    <MilestoneItemRoot>
      <IconCircle color={color}>
        <span className='material-symbols-outlined'>{icon}</span>
      </IconCircle>
      <Box>
        <Typography
          variant='caption'
          component='div'
          sx={{
            color: 'text.secondary',
            lineHeight: 1.2
          }}
        >
          {label}
        </Typography>
        <Typography
          variant='body2'
          component='div'
          sx={{
            fontWeight: 600,
            color,
            lineHeight: 1.2
          }}
        >
          {date}
        </Typography>
      </Box>
    </MilestoneItemRoot>
  )
}

export default MilestoneItem
